import React from 'react';
import "./confirmationModal.css";

const ConfirmationModal = (props) => {
    return (
        <div className='ConfirmationPopUp'>
            <p>{props.title}</p>
            {/* <hr /> */}
            <div className="buttons-confpopup">
                <button type="button" className="btn btn-outline-dark mx-3" onClick={props.noOption}> {props.localLang ? props.localLang["NO"] : "No"}</button>
                <button type="button" className="btn btn-primary" onClick={props.yesOption}>{props.localLang ? props.localLang["YES"] : "Yes"}</button>
            </div>
        </div>
    )
}

export default ConfirmationModal;